export default __webpack_public_path__ + "static/media/cs-campaigns-framed.b038c0ed.png";